import { DBModule, ModuleTypeId } from "../../types/DBTables";
//import { MD1_0 } from "../../types/ModuleDatas";
import { DTOModule } from "../../types/building";

export const extactModuleOrDefault = (modules: DTOModule[], modTypeId: ModuleTypeId) => {
  let module = modules.find((m) => (m.moduleTypeId = modTypeId));
  if (!module) {
    module = {
      moduleTypeId: modTypeId,
      data: {},
    } as DBModule;
  }

  return module;
};

// export const mD1_0ParameterNames = () => {
//   return {
//     byggnadsNamn: "byggnadsNamn",
//     företag: "företag",
//     område: "område",
//     adress: "adress",
//     postNr: "postNr",
//     ort: "ort",
//     kommun: "kommun",
//     byggnadArea: "byggnadArea",
//     verksamhet: "verksamhet",
//     nybyggnadsÅr: "nybyggnadsÅr",
//     energiKälla: "energiKälla",
//   } as MD1_0;
// };
